import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {ReactiveFormsModule} from '@angular/forms';
import {provideStates} from '@ngxs/store';
import {NgxPageScrollModule} from 'ngx-page-scroll';
import {BlogEntryComponent} from './blog-entry/blog-entry.component';
import {BlogRootComponent} from './blog-root/blog-root.component';
import {BlogListComponent} from './blog-list/blog-list.component';
import {BlogService} from './blog.service';
import {BlogState} from './state/blog.state';
import {BlogNewsletterComponent} from './blog-newsletter/blog-newsletter.component';
import {BlogConfirmSubscriptionComponent} from './blog-confirm-subscription/blog-confirm-subscription.component';
import {BlogUnsubscribeComponent} from './blog-unsubscribe/blog-unsubscribe.component';
import {MessagesModule} from '../../messages/messages.module';
import {MessagesState} from '../../messages/messages.state';
import {RtPlatformModule} from '../../rt-platform/rt-platform.module';
import {LayoutModule} from '../../layout/layout.module';
import {RtFormsModule} from '../../rt-forms/rt-forms.module';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

@NgModule({
  imports: [
    CommonModule,
    RtPlatformModule,
    LayoutModule,
    RouterModule.forChild([
      {
        path: '',
        component: BlogRootComponent,
        data: {
          title: 'Blog',
        },
      },
      {
        path: 'subscription/confirm',
        component: BlogConfirmSubscriptionComponent,
        data: {
          title: 'Confirm Subscription',
        },
      },
      {
        path: 'subscription/unsubscribe',
        component: BlogUnsubscribeComponent,
        data: {
          title: 'Unsubscribe',
        },
      },
      {
        path: ':slug',
        component: BlogEntryComponent,
        data: {
          title: 'Blog Entry',
        },
      },
      {
        path: ':name/:value',
        component: BlogListComponent,
        data: {
          title: 'Blog List',
        },
      },
    ]),
    NgxPageScrollModule,
    ReactiveFormsModule,
    RtFormsModule,
    MessagesModule,
    MatProgressSpinnerModule,
    BlogEntryComponent,
    BlogRootComponent,
    BlogListComponent,
    BlogNewsletterComponent,
    BlogConfirmSubscriptionComponent,
    BlogUnsubscribeComponent,
  ],
  providers: [provideStates([BlogState, MessagesState]), BlogService],
})
export class BlogModule {}
